module.exports = __webpack_public_path__ + "img/new2-1.8126ad21.png";